const initialState = {
  rentalBookings: { data: { result: [] }, total: 0 },
  rentalBookingDetail: null,
  rentalPaymentHistoryList: { data: { result: [] }, total: 0 },
  rentalPaymentHistoryDetail: null,
  loading: false,
};

export const rentalBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_RENTAL_BOOKINGS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        rentalBookings: null,
      };
    case "GET_RENTAL_BOOKINGS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        rentalBookings: action.payload,
      };
    case "GET_RENTAL_BOOKINGS_LIST_FAILED":
      return {
        ...state,
        loading: false,
        rentalBookings: action.payload,
      };

    case "GET_RENTAL_BOOKING_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        rentalBookingDetail: null,
      };
    case "GET_RENTAL_BOOKING_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        rentalBookingDetail: action.payload,
      };
    case "GET_RENTAL_BOOKING_VIEW_FAILED":
      return {
        ...state,
        loading: false,
        rentalBookingDetail: action.payload,
      };

    case "GET_RENTAL_PAYMENT_HISTORY_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        rentalPaymentHistoryList: null,
      };
    case "GET_RENTAL_PAYMENT_HISTORY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        rentalPaymentHistoryList: action.payload,
      };
    case "GET_RENTAL_PAYMENT_HISTORY_LIST_FAILED":
      return {
        ...state,
        loading: false,
        rentalPaymentHistoryList: action.payload,
      };

    case "GET_RENTAL_PAYMENT_HISTORY_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        rentalPaymentHistoryDetail: null,
      };
    case "GET_RENTAL_PAYMENT_HISTORY_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        rentalPaymentHistoryDetail: action.payload,
      };
    case "GET_RENTAL_PAYMENT_HISTORY_VIEW_FAILED":
      return {
        ...state,
        loading: false,
        rentalPaymentHistoryDetail: action.payload,
      };

    case "GET_RENTAL_PAYMENTS_REQUEST_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "GET_RENTAL_PAYMENTS_REQUEST_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        paymentsRequest: action.payload,
        error: null,
      };
    }
    case "GET_RENTAL_PAYMENTS_REQUEST_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case "UPDATE_RENTAL_STATUS_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "UPDATE_RENTAL_STATUS_SUCCESS": {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case "UPDATE_RENTAL_STATUS_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case "CANCEL_RENTAL_BOOKING_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "CANCEL_RENTAL_BOOKING_SUCCESS": {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case "CANCEL_RENTAL_BOOKING_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};